const memory = new Map();
export const safeStorage = {
  getItem(key) {
    if (memory.has(key)) return memory.get(key);
    try { return window.localStorage.getItem(key); } catch { return null; }
  },
  setItem(key, value) {
    memory.set(key, String(value));
    try { window.localStorage.setItem(key, String(value)); memory.delete(key); } catch { /* Keep shopping usable if storage is blocked. */ }
  },
  removeItem(key) {
    memory.set(key, null);
    try { window.localStorage.removeItem(key); memory.delete(key); } catch { /* Session-only fallback. */ }
  },
};
